// extracted by mini-css-extract-plugin
export var noResult = "schedules-search-results-module--noResult--17533";
export var result = "schedules-search-results-module--result--89ff0";
export var results = "schedules-search-results-module--results--d2e5c";
export var resultsTitle = "schedules-search-results-module--resultsTitle--32111";